import Vue from 'vue'

// Register in to use in client
export function usePluginInClient(plugin) {
  if (typeof window !== 'undefined') {
    Vue.use(plugin)
  }
}

// Register component by name so that we can use modal in anywhere
export const registerComponent = (Vue, component) => {
  Vue.component(component.name, component)
}

// Register component  & Add instance methods
export const registerComponentProgrammatic = (Vue, property, component) => {
  if (!Vue.prototype.$academy) Vue.prototype.$academy = {}
  Vue.prototype.$academy[property] = component
}
